import { Tab,
// Added Tab
Tabs,
// Added Tabs
NoticeBar,
// Added NoticeBar
Form,
// Added Form
RadioGroup,
// Added RadioGroup
Radio,
// Added Radio
Field,
// Added Field
Popup,
// Added Popup
Area,
// Added Area
Divider,
// Added Divider
Button,
// Added Button
Tag, Col, Icon, Cell, CellGroup, Swipe, Toast, SwipeItem, ActionBar, ActionBarIcon, ActionBarButton } from 'vant';
import { ref, watch, computed } from 'vue'; // Use ref, watch, computed from vue
import 'vant/es/toast/style';
// Removed axios import if only used for commented-out API
// import axios from 'axios';
// Removed areaList import
// import { areaList } from '@vant/area-data';
import { getUserInfo, rechargePhone, sendOauth } from '../../api/user'; // Removed rechargePower
import Storage from "../../utils/Storage";

// --- Mock Carrier Detection (Replace with actual API call or better logic) ---
function detectISP(phoneNumber) {
  if (!phoneNumber || phoneNumber.length < 3) return null;
  const prefix3 = phoneNumber.substring(0, 3);
  // Simplified Example Prefixes (Update with more comprehensive lists)
  const ydPrefixes = ["134", "135", "136", "137", "138", "139", "147", "150", "151", "152", "157", "158", "159", "172", "178", "182", "183", "184", "187", "188", "198"];
  const ltPrefixes = ["130", "131", "132", "145", "155", "156", "166", "171", "175", "176", "185", "186"];
  const dxPrefixes = ["133", "149", "153", "173", "177", "180", "181", "189", "191", "199"]; // 电信

  if (ydPrefixes.includes(prefix3)) return {
    code: 'YD',
    name: '中国移动'
  };
  if (ltPrefixes.includes(prefix3)) return {
    code: 'LT',
    name: '中国联通'
  };
  if (dxPrefixes.includes(prefix3)) return {
    code: 'DX',
    name: '中国电信'
  }; // Add DX for Telecom if needed

  // Add more checks or default logic here
  return null; // Or return a default/unknown type
}
// --- End Mock Carrier Detection ---

export default {
  components: {
    // Added Vant components used
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [NoticeBar.name]: NoticeBar,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    [Divider.name]: Divider,
    [Button.name]: Button,
    // Original components
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ActionBar.name]: ActionBar,
    [ActionBarIcon.name]: ActionBarIcon,
    [ActionBarButton.name]: ActionBarButton
    // [ref.name]: ref, // ref is not a component
  },
  setup() {
    const wallet = ref(0);
    const telephone = ref('');
    const address = ref(''); // To display detected carrier name
    const ISP = ref(''); // To store 'YD', 'LT', 'DX' etc.
    const active_num = ref(1); // Index for selected price

    const priceList = ref({
      // Made priceList a ref
      'YD': [{
        'rechargePrice': "话费 100",
        'payPrice': '96 元',
        'price': 100,
        'dk': 4
      }, {
        'rechargePrice': "话费 200",
        'payPrice': '191 元',
        'price': 200,
        'dk': 9
      }],
      'LT': [{
        'rechargePrice': "话费 100",
        'payPrice': '96 元',
        'price': 100,
        'dk': 4
      }, {
        'rechargePrice': "话费 200",
        'payPrice': '191 元',
        'price': 200,
        'dk': 9
      }
      // {'rechargePrice': "话费 300", 'payPrice': '273 元', 'price': 300, 'dk': 27},
      ],
      'DX': [
      // Added example for Telecom (电信) - ADJUST AS NEEDED
      {
        'rechargePrice': "话费 100",
        'payPrice': '96 元',
        'price': 100,
        'dk': 4
      }, {
        'rechargePrice': "话费 200",
        'payPrice': '191 元',
        'price': 200,
        'dk': 9
      }]
      // Add 'DX' for Telecom if needed, matching your backend/API structure
    });

    // --- Computed Properties ---
    const currentPriceOptions = computed(() => {
      return priceList.value[ISP.value] || [];
    });
    const selectedPriceItem = computed(() => {
      const options = currentPriceOptions.value;
      if (options && options.length > 0 && active_num.value > 0 && active_num.value <= options.length) {
        return options[active_num.value - 1];
      }
      return null;
    });

    // Calculate actual deductible amount
    const deductibleAmount = computed(() => {
      if (!selectedPriceItem.value) return 0;
      const maxDeductible = selectedPriceItem.value.dk || 0;
      return Math.min(maxDeductible, wallet.value).toFixed(2); // Use Math.min and ensure 2 decimal places
    });

    // Calculate final payment amount shown on the button
    const finalPayAmount = computed(() => {
      if (!selectedPriceItem.value) return '0.00';
      // Extract numeric value from payPrice string (e.g., '95 元' -> 95)
      // This is fragile; ideally, payPrice should be a number in the data source
      const basePayPrice = selectedPriceItem.value.price; // Fallback to price if payPrice is not numeric
      const actualDeduct = parseFloat(deductibleAmount.value);
      const payAmount = basePayPrice - actualDeduct;

      // Alternative calculation based on 'price' and 'dk'
      // const price = selectedPriceItem.value.price;
      // const actualDeduct = parseFloat(deductibleAmount.value);
      // const payAmount = price - actualDeduct;

      return payAmount.toFixed(2); // Ensure 2 decimal places
    });

    // --- Watcher for Phone Number ---
    watch(telephone, newVal => {
      address.value = ''; // Reset address display
      ISP.value = ''; // Reset ISP
      active_num.value = 1; // Reset selection
      if (/^1[3-9]\d{9}$/.test(newVal)) {
        // Use the mock detection function
        const detected = detectISP(newVal);
        if (detected) {
          ISP.value = detected.code;
          address.value = detected.name; // Display name like "中国移动"
          // Check if options exist for this ISP, reset active_num if needed
          if (!priceList.value[ISP.value] || priceList.value[ISP.value].length === 0) {
            active_num.value = 0; // Indicate no valid selection
            address.value += " (暂无可用充值)"; // Update display
          } else {
            active_num.value = 1; // Default to first option
          }
        } else {
          address.value = "未知运营商";
          ISP.value = ''; // Clear ISP if unknown
          active_num.value = 0; // No valid selection
        }
        // --- Replace mock with actual API call if available ---
        // axios.get('YOUR_API_ENDPOINT?phone=' + newVal)
        //   .then(res => {
        //     if (res.data && res.data.carrierCode) { // Adjust based on your API response
        //       ISP.value = res.data.carrierCode; // e.g., 'YD'
        //       address.value = res.data.carrierName; // e.g., '中国移动'
        //       // Reset active_num if needed
        //     } else {
        //       address.value = "无法识别运营商";
        //     }
        //   })
        //   .catch(err => {
        //     console.error("Carrier lookup failed:", err);
        //     address.value = "查询失败";
        //   });
        // --- End API call section ---
      }
    });

    // --- Methods ---
    const fetchUserInfo = () => {
      getUserInfo().then(response => {
        wallet.value = response.data.wallet;
      }).catch(err => {
        console.error("Failed to fetch user info:", err);
        Toast('获取用户信息失败');
      });
    };
    const handleOauth = query => {
      if (query.code !== undefined) {
        let params = {
          code: query.code,
          access_token: query.state
        };
        sendOauth(params).then(result => {
          Storage.set('users', result.token);
          fetchUserInfo(); // Fetch info after successful OAuth
        }).catch(err => {
          console.error("OAuth failed:", err);
          alert('授权失败，请重试或联系客服');
        });
        return true; // Indicate OAuth was handled
      }
      return false; // Indicate no OAuth code present
    };
    const onSwitch = index => {
      active_num.value = index;
    };
    const telSubmit = () => {
      if (!selectedPriceItem.value) {
        Toast("请先选择充值金额");
        return;
      }
      const currentSelection = selectedPriceItem.value;
      const deduction = parseFloat(deductibleAmount.value); // Use the calculated deductible amount

      if (wallet.value < deduction) {
        // Check if wallet balance is sufficient for the *deductible* part
        Toast("可用抵扣额度不足，请先充值");
        return;
      }
      // Validate again just before submitting
      if (!telephone.value || !ISP.value || !currentSelection) {
        Toast('信息不完整，请检查手机号和充值选项');
        return;
      }
      let data = {
        telephone: telephone.value,
        isp_code: ISP.value,
        // Send ISP code (e.g., 'YD', 'LT')
        // isp_name: address.value, // Optional: send ISP name if needed by backend
        amount: currentSelection.price,
        // Send the *original* recharge amount (e.g., 100, 200)
        recharge_type: 'telephone'
        // You might need to send the selected product ID if your backend uses it
        // type_id: currentSelection.type_id (if you add type_id to priceList)
      };
      console.log("Submitting recharge data:", data);
      Toast.loading({
        message: '正在提交...',
        forbidClick: true
      });
      rechargePhone(data).then(response => {
        Toast.clear();
        // Ensure response format is correct for WeixinJSBridge
        if (typeof WeixinJSBridge === "undefined") {
          Toast.fail('请在微信客户端打开');
          return;
        }
        if (!response || typeof response !== 'object' || !response.appId) {
          console.error("Invalid payment parameters received:", response);
          Toast.fail('支付参数错误，请稍后重试');
          return;
        }
        WeixinJSBridge.invoke('getBrandWCPayRequest', response,
        // Should contain { appId, timeStamp, nonceStr, package, signType, paySign }
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            Toast.success("支付成功");
            setTimeout(() => {
              // Consider navigating to order details or refreshing user info
              // this.$router.replace('/order'); // Use this.$router in options API context
              fetchUserInfo(); // Refresh wallet balance
            }, 1500);
          } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
            Toast('支付已取消');
          } else {
            Toast.fail('支付失败: ' + res.err_msg);
            console.error("Weixin Pay Error:", res);
          }
        });
      }).catch(error => {
        var _error$response;
        Toast.clear();
        console.error("Recharge API call failed:", error);
        const errorMsg = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.message) || '订单提交失败，请重试';
        Toast.fail(errorMsg);
      });
    };

    // --- Return setup context ---
    return {
      wallet,
      telephone,
      address,
      ISP,
      // Expose ISP if needed elsewhere, though maybe not directly in template
      active_num,
      priceList,
      // Expose for potential direct use if needed, though computed is better
      // Computed properties
      currentPriceOptions,
      selectedPriceItem,
      deductibleAmount,
      finalPayAmount,
      // Methods
      fetchUserInfo,
      handleOauth,
      onSwitch,
      telSubmit
    };
  },
  created() {
    // Use this.$route in Options API context
    const route = this.$route;
    if (!this.handleOauth(route.query)) {
      // If not handling OAuth, check for existing token and fetch user info
      if (Storage.get('users')) {
        this.fetchUserInfo();
      } else {
        // Handle case where user is not logged in and no OAuth code is present
        // Maybe redirect to login or show a message
        console.log("User not logged in and no OAuth code.");
        // Optionally prompt for login or handle as needed
      }
    }
  }
  // Removed methods previously in options API if now handled in setup
};